export default [
  {
    path: '/activity-20260518-main',
    component: () => import('./Page.vue'),
    meta: { title: '520爱的告白季', id: 29 },
  },
  {
    path: '/activity-20260518-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '520爱的告白季-规则', id: 29 },
  },
]
